import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M12 16.7076L6.34619 11.0538L7.40002 10L12 14.6L16.6 10L17.6538 11.0538L12 16.7076Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map